/**
* Typing indicator component with animated dots
*/

import type { ThemePalette } from '../utils/themeUtils'
import { TYPING_ANIMATION_CSS } from '../constants'

interface TypingIndicatorProps {
    palette: ThemePalette
}

export function TypingIndicator({ palette }: TypingIndicatorProps) {
    return (
        <>
        <style>{TYPING_ANIMATION_CSS}</style>
        <div
        style={{
            alignSelf: 'flex-start',
            maxWidth: '82%',
            padding: '12px 16px',
            borderRadius: '18px 18px 18px 4px',
            background: palette.assistantBubble,
            color: palette.textSecondary,
            fontSize: '13px',
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
        }}
        >
        <span style={{ 
            display: 'flex',
            gap: '4px',
            alignItems: 'center',
        }}>
        <span style={{
            width: '6px',
            height: '6px',
            borderRadius: '50%',
            background: palette.textSecondary,
            animation: 'typing-dot 1.4s infinite ease-in-out',
            animationDelay: '0s',
        }} />
        <span style={{
            width: '6px',
            height: '6px',
            borderRadius: '50%',
            background: palette.textSecondary,
            animation: 'typing-dot 1.4s infinite ease-in-out',
            animationDelay: '0.2s',
        }} />
        <span style={{
            width: '6px',
            height: '6px',
            borderRadius: '50%',
            background: palette.textSecondary,
            animation: 'typing-dot 1.4s infinite ease-in-out',
            animationDelay: '0.4s',
        }} />
        </span>
        <span>Assistant is typing...</span>
        </div>
        </>
    )
}
